// Device and browser capability checks.
// Used to detect AR support before starting a session.

/**
 * Returns true if the browser has the minimum capabilities required for
 * the AR experience:
 *   - Secure context (required for camera access on mobile)
 *   - WebGL support (required by the XR8 engine)
 *
 * This is a conservative pre-flight check. XR8 itself will surface more
 * specific errors (camera denial, unsupported device) at session start.
 */
export function isARSupported(): boolean {
  if (typeof window === 'undefined') return false;

  if (!window.isSecureContext) return false;

  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl') ||
      (canvas.getContext('experimental-webgl') as WebGLRenderingContext | null);
    if (!gl) return false;
  } catch {
    return false;
  }

  return true;
}
